import _ from 'lodash'
import {INITIALIZE} from "./available";

export default {
  [INITIALIZE] (state, initialData) {
    state.initialized = true
    state.user = _.get(initialData, 'user', {})
    state.availableClients = _.get(initialData, 'availableClients', {})
    state.availableClientsById = _.keyBy(state.availableClients, 'id')
    state.currentClientId = _.get(state.availableClients, [0, 'id'], null)
    state.currentClient = _.get(state.availableClientsById, state.currentClientId, {}),
    state.availableCaseStatuses = _.get(initialData, 'availableCaseStatuses', [])
    state.availableCaseStatusesByValue = _.keyBy(state.availableCaseStatuses, 'value')
    state.availableCaseCreationOrderStatuses = _.get(initialData, 'availableCaseCreationOrderStatuses', [])
    state.availableCaseCreationOrderStatusesByValue = _.keyBy(state.availableCaseCreationOrderStatuses, 'value')
    state.availableUsers = _.get(initialData, 'availableUsers', [])
    state.availableUsersById = _.keyBy(state.availableUsers, 'id')
    state.availableServices = _.get(initialData, 'availableServices', [])
    state.availableServicesById = _.keyBy(state.availableServices, 'id')
    state.servicesByClients = _.get(initialData, 'servicesByClients', {})
  }
}
